import { render, staticRenderFns } from "./CustomerUserShow.vue?vue&type=template&id=5d4574d9"
import script from "./CustomerUserShow.vue?vue&type=script&lang=ts"
export * from "./CustomerUserShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports